/**
 * Media Insight API — binding to the shared createMediaInsightApi(http)
 * factory in packages/common, bound to web's apiClient singleton.
 */

import { apiClient } from "@/lib/api/client";
import { createMediaInsightApi } from "@speakai/common/src/media-insight/api";

export type { SpeakerUpdateEntry } from "@speakai/common/src/media-insight/api";
export type {
  MediaInsightSummary,
  MediaInsightSentimentDocument,
  InsightKeyword,
  InsightSpeaker,
  MediaInsightSentimentEntry,
  MediaInsightResponse,
  MediaStatusResult,
  TextInsightResponse,
} from "@speakai/common/src/media-insight/types";

export const {
  getMediaStatus,
  getMediaInsight,
  getTextInsight,
  updateSpeakers,
  analyzeMedia,
} = createMediaInsightApi(apiClient);
